/** Mirrors services/customer_chat_nlu.CVAC_GUIDED_DATES_PREFIX */
export const CVAC_GUIDED_DATES_PREFIX = "__cvac_guided_dates__|";

function guidedDatesModeKey(qr) {
  const v = String(qr?.value || "");
  if (!v.startsWith(CVAC_GUIDED_DATES_PREFIX)) return null;
  return v.slice(CVAC_GUIDED_DATES_PREFIX.length).trim().toLowerCase();
}

/** גמיש / תאריכים מדויקים / חודש ספציפי — shown together in guided dates step */
export function isGuidedPrimaryDateModeReply(qr) {
  const key = guidedDatesModeKey(qr);
  return key === "flex" || key === "exact" || key === "pick_month";
}

export function filterOutGuidedPrimaryDateModeReplies(quickReplies) {
  return (quickReplies || []).filter((qr) => !isGuidedPrimaryDateModeReply(qr));
}
